/**
 * A tiny layout cursor for vertical flow content, with basic pagination helpers.
 */

export function createCursor({ marginLeft = 10, marginRight = 10, marginTop = 10, marginBottom = 25, y = 10 } = {}) {
  return {
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
    x: marginLeft,
    y,
  };
}

export function getPageSize(doc) {
  return {
    width: doc.internal.pageSize.getWidth(),
    height: doc.internal.pageSize.getHeight(),
  };
}

/**
 * Ensures there is at least `mmNeeded` vertical space remaining on the current page.
 * If not, it adds a page and resets cursor.y to `nextPageStartY`.
 */
export function ensureSpace(doc, cursor, mmNeeded, { nextPageStartY = cursor.marginTop, onNewPage } = {}) {
  const { height } = getPageSize(doc);
  const usableBottomY = height - cursor.marginBottom;
  const willOverflow = cursor.y + mmNeeded > usableBottomY;

  if (!willOverflow) return false;

  doc.addPage();
  cursor.y = nextPageStartY;
  cursor.x = cursor.marginLeft;
  if (typeof onNewPage === "function") onNewPage();
  return true;
}


